export const PRODUCT_LINE = "Veto Reviews";
export const FLOW_NAME = "Buyer Funding Review";
export const RECEIPT_NAME = "Buyer Funding Review Receipt";
export const CORE_MODEL = "Four-way funding match";
export const STANDARD =
  "No buyer funds are requested, accepted, marked ready, applied, or relied on without a Buyer Funding Review Receipt or owner-approved exception.";
export const TRUST_BOUNDARY =
  "Veto records the review. It does not approve, authorize, guarantee, insure, verify, release funds, confirm bank accounts, authenticate payees, or make funds safe to rely on. The office decides.";

export const FORBIDDEN_PHRASES = [
  "buyer verification",
  "cash-to-close verification",
  "plaid verification",
  "good funds verification",
  "funds approved",
  "buyer approved",
  "safe to close",
  "safe to wire",
  "good funds confirmed",
  "buyer verified",
  "account verified",
  "funds verified",
  "approved",
  "authorized",
  "guaranteed",
  "protected",
  "insured",
  "fraud prevented",
  "wire secured",
  "bank confirmed",
  "payor authenticated"
] as const;

export const REVIEW_STATES = [
  "Draft",
  "Missing information",
  "Ready for review",
  "Exception required",
  "Recorded",
  "Archived",
  "Error",
  "Unable to check",
  "Hold / conflicting instructions reported"
] as const;

export const FUNDS_STATUSES = [
  "Not requested",
  "Requested",
  "Buyer acknowledged",
  "Initiated",
  "Received - not matched",
  "Received - matched",
  "Received - partially matched",
  "Held",
  "Applied to file",
  "Returned",
  "Reversed / returned by bank",
  "Unable to determine"
] as const;

export const MATCH_STATUSES = [
  "Matched",
  "Partially matched",
  "Did not match",
  "Not recorded",
  "Unable to check",
  "Not applicable",
  "Open gap retained"
] as const;

export const OFFICE_ACTIONS = [
  "Accepted for file",
  "Held pending review",
  "Applied to file",
  "Applied partial funds",
  "Requested additional funds",
  "Requested revised instructions",
  "Requested source evidence",
  "Requested initiation evidence",
  "Requested inbound receipt evidence",
  "Requested manager / owner review",
  "Returned / rejected funds",
  "Recorded overage",
  "Recorded shortage",
  "Recorded third-party source",
  "Recorded exception",
  "No action taken"
] as const;

export const PAYMENT_RAILS = [
  "Wire",
  "ACH",
  "Same-day ACH",
  "RTP",
  "FedNow",
  "Payment provider",
  "Cashier's check",
  "Personal check",
  "Certified check",
  "Internal transfer",
  "Multiple rails",
  "Unknown"
] as const;

export const FUNDING_PURPOSES = [
  "Cash to close",
  "Earnest money deposit",
  "Additional deposit",
  "Shortage",
  "Revised cash to close",
  "Split funding",
  "Gift funds",
  "Entity / trust / third-party funding"
] as const;

export const GAP_TYPES = [
  "Amount mismatch",
  "Sender/source mismatch",
  "Instruction mismatch",
  "Receiving account mismatch",
  "Rail mismatch",
  "Missing buyer acknowledgment",
  "Missing source account evidence",
  "Missing initiation evidence",
  "Missing inbound receipt",
  "Missing file number / memo",
  "Third-party source",
  "Gift funds missing evidence",
  "ACH return risk",
  "Timing / cutoff",
  "Stale evidence",
  "Manual-only evidence",
  "Other"
] as const;

export const PROVIDER_LIMITATIONS = [
  {
    provider: "Plaid",
    limitation:
      "Account owner / balance evidence was recorded at the evidence timestamp. This evidence does not guarantee final settlement, future balance, account control, or absence of return/reversal risk."
  },
  {
    provider: "CertifID",
    limitation:
      "CertifID result recorded as vendor evidence. Veto did not independently approve, guarantee, insure, or authorize reliance on the funds."
  },
  {
    provider: "Closinglock",
    limitation:
      "Closinglock result recorded as vendor evidence. Wire/payment status and insurance terms, if any, are controlled by the provider record and office policy."
  },
  {
    provider: "Manual evidence",
    limitation:
      "Manual evidence recorded by the operator. No automated source-account check was performed."
  }
] as const;
